import React from 'react';

import { Box } from '@opendoor/bricks/core';
import { HUB_INNER_HEADER_ID } from 'platform/components/layout/InnerHeader';

const PROGRESS_BAR_HEIGHT = 5;

/**
 * Component that renders the layout for the HelloSign step in the wizard.
 * It wraps its children in a Box whose height is 100vh minus the height of the top header and the progress bar
 *
 * ------------------
 * |     Header     |
 * ------------------
 * |  Progress bar  | Always 5 px
 * ------------------
 * |    Content     |
 * ------------------
 *
 * component-test-check-ignore storybook-check-ignore
 */
export const HelloSignWizardLayout: React.FC = ({ children }) => {
  const hubTopNavigationHeight = document.getElementById(HUB_INNER_HEADER_ID)?.offsetHeight || 0;
  return (
    <Box height={`calc(100vh - ${hubTopNavigationHeight + PROGRESS_BAR_HEIGHT}px)`}>{children}</Box>
  );
};
